window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

var menu = document.getElementById("menu");
var main = document.getElementById("main");

// show the menu
function openMenu() {
    menu.classList.remove('-ml-56');
    menu.classList.add('ml-0');
}

// make the menu "go away"
function closeMenu() {
    menu.classList.remove('ml-0');
    menu.classList.add('-ml-56');
}

import { VmPlayer, VmVideo, VmFile, defineCustomElements } from '@vime/core';
